import React, { useContext } from 'react';
import { Drawer, Divider } from 'antd';

import UserContext from 'components/Provider/UserProvider';
import Logout from 'components/Elements/Shared/Logout';
import UserAvatar from 'components/Elements/Shared/UserAvatar';
import Header from './Header';
import Navigation from './Navigation';
import { darkBackground } from '../../../../constants/colors';
import styles from './Drawer.module.css';

export default ({ isVisible, onCloseDrawer }) => {
  const { user } = useContext(UserContext);

  return (
    <Drawer
      className={styles.drawer}
      title={<Header />}
      placement="left"
      closable
      onClose={onCloseDrawer}
      open={isVisible}
      zIndex={1002}
      width="auto"
      styles={{
        body: {
          padding: 16,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100% - 53px)',
          justifyContent: 'space-between',
        },
        header: {
          backgroundColor: darkBackground,
          padding: 0,
          borderRadius: 0,
        },
      }}
    >
      <span>
        <UserAvatar textPosition="right" />
        <Divider className={styles.divider} />
        <Navigation onCloseDrawer={onCloseDrawer} />
      </span>
      {user && <Logout />}
    </Drawer>
  );
};
